export const LIMIT_MIN_DEPOSIT = 100
export const LIMIT_MAX_DEPOSIT = 1000000
export const LIMIT_MIN_GAME_DAY = 1
export const LIMIT_MAX_GAME_DAY = 24
export const LIMIT_MIN_GAME_WEEK = 1
export const LIMIT_MAX_GAME_WEEK = 7
export const DEFAULT_DEPOSIT = {
  DAY: '50000',
  WEEK: '50000',
  MONTH: '200000',
}
export const DEFAULT_VALUE = {
  GAME_DAY: '8', // hours
  GAME_WEEK: '6', // days
}
export const MAX_VALUE = {
  GAME_DAY: '24',
  GAME_WEEK: '7', // 604800
  DEPOSIT: '1000000',
  UN_LIM: '0',
}
export const LIMIT_TYPE = {
  DEPOSIT: 'deposit',
  GAME_DAY: 'gameDay',
  GAME_WEEK: 'gameWeek',
  INFO: 'info',
}
export const LIMIT_MAX = {
  GAME_DAY: '24',
  GAME_WEEK: '7',
  GAME_DEPOSIT: '1000000',
}

export const ERROR = {
  POST: {
    cantChange: 'limit_can_not_be_changed',
  },
}

export const BE_LIMIT_TYPE = {
  GAME_SESSION: 'game_session',
  DEPOSIT: 'deposit',
}

export const DELIMITER_GAME = {
  WEEK: 'week',
  DAY: 'day',
}

export const DELIMITER_DEPOSIT = {
  MONTH: 'month',
  WEEK: 'week',
  DAY: 'day',
}
